import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePageWithBody } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/sent")({
  loader: async () => {
    const page = await loadStandalonePageWithBody({ data: { path: "sent.md" } });
    return { title: (page.title as string) || "Thank You", html: page.html as string };
  },
  head: ({ loaderData }) => ({ meta: seo({ title: loaderData?.title || "Thank You", url: "/sent", noindex: true }),
    links: seoLinks({ url: "/sent" }), }),
  component: () => {
    const { title, html } = Route.useLoaderData();
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 text-center md:px-8">
        <h1 className="mb-6 text-4xl font-bold text-charcoal">{title}</h1>
        {html && <div className="content" dangerouslySetInnerHTML={{ __html: html }} />}
      </div>
    );
  },
});
